import React,{useState,useEffect} from 'react';
import {Link} from 'react-router-dom';
import {signout,isAuthenticated} from '../../auth/authenticate';
import axios from 'axios';
import css from './Navbar.module.css';


const Navbar1=(props)=> {
    let role;
    if(isAuthenticated()){
        if(isAuthenticated().data)
        {
            role = isAuthenticated().data.user.role;

        }else{

            role=0;
        }
    }else{
        role=0;
    }
    //-------------------fb------------------------//
    const [authenticated,setAuthenticated] = useState(false);
    const fetLoginFb =()=>{
        setAuthenticated(false);
        let config = {
            headers: {
                'Access-Control-Allow-Origin:':'*',
                'Access-Control-Allow-Credentials':true,
            }
          }
        axios.get('/login/success',config)
        .then(data=>{
            localStorage.setItem('jwt',JSON.stringify(data.data.user))
            setAuthenticated(true);
        })
        .catch(err=>{
            console.log(err)
        })
    };
useEffect(()=>{
    fetLoginFb();
},[]);
//----------------------------------------------//

    const navbar1 =()=>(
        <nav className="navbar navbar-expand"style={{"height":"35px",backgroundColor:"#e5e5e5"}}> 
        <div className="container-fluid">
        <i className={`${css.Hello} fa fa-phone`} style={{color:"#700"}} ></i>
        <span className={`${css.Hello} navbar-brand mb-0`}style={{"color":"#700",fontSize:"13px"}}>Liên hệ: 0768550509</span>
        <ul className="navbar-nav ml-auto"> 
        <li className={`${css.Hello} nav-item mr-3`}> 
        Xin chào,
        </li>
            {!(isAuthenticated()||authenticated)? (
                <React.Fragment>

                <li className="nav-item"> 
                <Link className='my-auto' style={{textAlign:"center","fontSize":"13px"}} to="/signin"><i className="fas fa-sign-in-alt"></i><span > Đăng nhập</span></Link>
                </li>
                <li className="nav-item"> 
                <Link className='my-auto ml-3' style={{textAlign:"center","fontSize":"13px",}} to="/signup"><i className="fas fa-user-plus"></i><span > Đăng ký</span></Link>
                </li>
                </React.Fragment>
            ):
            (    <React.Fragment>
                {role === 0?(
                   <li  className="nav-item">
                   <Link className='my-auto ml-3' style={{textAlign:"center","fontSize":"13px",}} to="/user/dashboard">
                   <i className="fas fa-user"></i><span >Trang cá nhân</span>
                   </Link>
                   </li> 
            ):(
                <li  className="nav-item">
                <Link className='my-auto ml-3' style={{textAlign:"center","fontSize":"13px",}} to="/admin/dashboard">
                <i className="fas fa-user"></i><span >Admin</span>
                </Link>
                </li>  
                 
            )}
            <li  className="nav-item">
            <Link onClick={()=>signout()} className='my-auto ml-3' style={{textAlign:"center","fontSize":"13px",}} to="/">
                <i className="fas fa-sign-out-alt"></i><span > Đăng xuất</span>
            </Link>
            </li>
             </React.Fragment>
            )}
        </ul> 
        </div>
        </nav>
    )
    return (
        <div>
            {navbar1()}
        </div>
    );
}

export default Navbar1;